/**
 * BIAT Animation - Product Page & Technology Page
 * Vanilla JavaScript replacement for jQuery-based scroll animations
 */

class BIATAnimation {
  constructor() {
    this.desktopGroups = [
      ['.biat-item-1', '.biat-item-4'],
      ['.biat-item-2', '.biat-item-5'],
      ['.biat-item-3', '.biat-item-6'],
      ['.biat-item-7', '.biat-item-8']
    ];
    this.currentDesktopGroup = 0;
    this.isDesktopAnimating = false;
    this.init();
  }

  init() {
    // Check if biat section exists
    const biatSection = document.querySelector('.biat-section');
    if (!biatSection) {
      return;
    }

    // Ensure initial states are set
    this.setInitialStates();

    // Setup scroll handler with throttling
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          this.handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    // Handle window resize
    window.addEventListener('resize', () => {
      if (window.innerWidth < 992) {
        const items = document.querySelectorAll('.biat-item-1, .biat-item-2, .biat-item-3, .biat-item-4, .biat-item-5, .biat-item-6, .biat-item-7, .biat-item-8');
        items.forEach(item => {
          item.style.opacity = '1';
          item.style.transform = 'translateX(0)';
        });
      } else {
        // Reset to initial states on desktop resize
        this.setInitialStates();
        this.currentDesktopGroup = 0;
      }
    });

    // Trigger on initial load if section is already visible
    setTimeout(() => {
      this.handleScroll();
    }, 100);
  }

  setInitialStates() {
    const isMobile = window.innerWidth < 992;
    
    // Ensure all biat items start with proper initial states
    const allItems = document.querySelectorAll('.biat-item-1, .biat-item-2, .biat-item-3, .biat-item-4, .biat-item-5, .biat-item-6, .biat-item-7, .biat-item-8');
    allItems.forEach(item => {
      if (isMobile) {
        // Mobile: visible by default
        item.style.opacity = '1';
        item.style.transform = 'translateX(0)';
      } else {
        // Desktop: hidden initially, will be animated on scroll
        if (!item.style.opacity || item.style.opacity === '1') {
          item.style.opacity = '0';
          if (item.classList.contains('biat-item-1') || 
              item.classList.contains('biat-item-2') || 
              item.classList.contains('biat-item-3') ||
              item.classList.contains('biat-item-7')) {
            item.style.transform = 'translateX(-40px)';
          } else {
            item.style.transform = 'translateX(40px)';
          }
        }
      }
    });
  }

  handleScroll() {
    const isMobile = window.matchMedia('(max-width: 991px)').matches;
    if (isMobile) return; // Mobile items are already visible

    if (this.currentDesktopGroup >= this.desktopGroups.length || this.isDesktopAnimating) return;

    const scrollPosition = window.scrollY + window.innerHeight;
    const firstElement = document.querySelector(this.desktopGroups[this.currentDesktopGroup][0]);

    if (firstElement) {
      const elementTop = firstElement.getBoundingClientRect().top + window.scrollY;
      const triggerPoint = elementTop - (window.innerHeight * 0.2); // Trigger when 20% from top

      if (scrollPosition > triggerPoint) {
        this.isDesktopAnimating = true;

        // Animate all elements in current group
        this.desktopGroups[this.currentDesktopGroup].forEach(selector => {
          const elements = document.querySelectorAll(selector);
          elements.forEach(element => {
            element.style.opacity = '1';
            element.style.transform = 'translateX(0)';
          });
        });

        setTimeout(() => {
          this.isDesktopAnimating = false;
          this.currentDesktopGroup++;
        }, 300);
      }
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new BIATAnimation());
} else {
  new BIATAnimation();
}

